<template>
  <div class="col setlvl">
    <div class="col-claim">
      <div class="wrap">
        <div class="happy-head">
          <div ref="head" class="head"></div>
          <div ref="messageCloud" class="messageClumb">
            <h3>Wybierz <br />poziom gry</h3>
          </div>
        </div>
      </div>
      <div class="action-bar">
        <button class="btn btn-green-light" ref="btn1" @click="setLevel('easy')"><span>ŁATWY</span></button>
        <button class="btn btn-blue"  ref="btn2" @click="setLevel('hard')"><span>TRUDNY</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import MoleculesMissionName from "@/molecules/MoleculeMissionName";
import {TimelineLite} from "gsap";
export default {
name: "OrganismSelectLevel",
  components:{
    MoleculesMissionName
  },
  data(){
    return{
      gamenameGTM: '',
    }
  },
  computed:{
    ...mapGetters(['setupGame']),
  },
  methods: {
    ...mapActions(['setDifficulty','audioPlayer','stopAudio']),
    setLevel(payload){
      this.setDifficulty(payload)
      this.stopAudio()
      if (payload == 'easy'){
        this.audioPlayer({  'url': [ '/game_level/latwy_select.mp3' ]})



        this.$gtm.push({
          event: 'ms-gameevent',
          category: "Misja samodzielność",
          action: "Kliknięcie w button - ŁATWY",
          label: this.gamenameGTM+": Wybór poziomu trudności",  //  gameType
        })


      }else{
        this.audioPlayer({ 'url': ['/game_level/trudny_select.mp3' ]})
        this.$emit('gameLimit',60)


        this.$gtm.push({
          event: 'ms-gameevent',
          category: "Misja samodzielność",
          action: "Kliknięcie w button - TRUDNY",
          label: this.gamenameGTM +": Wybór poziomu trudności",  //  gameType
        })

      }
      this.$emit('gameIntro', true)
    }
  },
  mounted() {
    const timeline = new TimelineLite()
    const { messageCloud } = this.$refs
    const { head } = this.$refs
    timeline
      .set(messageCloud,  {scale: 0, y : -100})
      .set(head,  {  scale: 0.5,})
      .to(head,  { scale: 1,} )
      .to(messageCloud,  {   scale:1, y : -10});

    if (this.setupGame.gameType == 1){
      this.gamenameGTM = "Pieniądze od podszewki"
    }else if(this.setupGame.gameType == 2){
      this.gamenameGTM = "Misja bezpieczeństwo"
    }else if(this.setupGame.gameType == 3){
      this.gamenameGTM = "Zarządzam budżetem"
    }

  }
}
</script>
